import React from 'react';
import PropTypes from 'prop-types';
import Preview from './preview';
import DeleteButton from '../utils/delete-button';

const FileThumbnail = props => {
  return (
    <div className="fadein">
      <Preview {...props} />
      <DeleteButton handleDelete={() => props.onRemoveThumbnail(props.file)} />
    </div>
  );
};

FileThumbnail.propTypes = {
  file: PropTypes.object.isRequired,
  onRemoveThumbnail: PropTypes.func,
  withOrientation: PropTypes.bool,
};

export default FileThumbnail;
